export const REVIEW_REASONS = [
    { value: 'Items are damaged / in poor condition', label: 'Items are damaged / in poor condition' },
    { value: 'Brand isn\'t supported', label: 'Brand isn\'t supported' },
    { value: 'Items are fake', label: 'Items are fake' },
    { value: 'Other', label: 'Other' },
]